import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import AppRoutes from './router';
import ImpersonationBanner from './components/ImpersonationBanner';
import ErrorBoundary from './components/ErrorBoundary';
import './components/i18n';

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          {/* Renders nothing unless this tab is a superadmin role preview. */}
          <ImpersonationBanner />
          {/* A crash on one screen must not blank the entire app. */}
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;